import React from 'react';

function DeliveryOverview() {
  return (
    <div>
      <p><b>Shipping</b></p>
      <p>Jane Doe</p>
      <p>6301 Firch Path</p>
      <p>New Albany, OH 43054</p>
      <p>USA</p>
      <p><br /></p>
      <p><b>Shipping Speed</b></p>
      <p>Standard $7</p>
    </div>
  );
}

export default DeliveryOverview;
